export default {
  orders: {
    isLoading: false,
    data: [],
    count: 0,
    status: null,
    error: false,
    errorMessage: null
  },
  order: {
    isLoading: false,
    data: {},
    status: null,
    error: false,
    errorMessage: null
  },
  qrCode: {
    isLoading: false,
    data: {},
    status: null,
    error: null,
    errorMessage: null
  }
};
